export default "__VITE_ASSET__BYvlMvXJ__"